import { ApplicationController, useIntersection } from 'stimulus-use';
import Plyr from 'plyr';

const videos = [];
let videoCount = 0;
export default class extends ApplicationController {
  static targets = ['poster', 'button', 'plyr'];
  static values = {
    settings: { type: Object, default: {} },
  };
  static classes = ['animateIn'];

  connect() {
    this.plyrIsReady = false;
    this.plyrElement = Array.from(this.element.childNodes).find((el) => 
      ['IFRAME', 'VIDEO'].includes(el.nodeName));
    this.plyrType = this.plyrElement.nodeName;
    // Adding id to identify
    this.element.setAttribute('id', `video-${videoCount}`);
    videoCount++;

    this.plyrContainer =
      this.plyrType == 'IFRAME' ? this.element : this.plyrElement;

    this.plyr = new Plyr(this.plyrContainer, {
      ...this.settingsValue,
      poster: this.element.dataset.poster,
    });
    videos.push(this.plyr);
    this.plyr.on('ready', this.onReady.bind(this));
    this.plyr.on('play', this.onPlay.bind(this));
    this.plyr.on('playing', this.onPlaying.bind(this));
    this.plyr.on('pause', this.onPause.bind(this));
    document.addEventListener('turbo:before-cache', this.teardown.bind(this));
  }

  onPauseVideos(videos, videoToFilter) {
    let idToFilter = videoToFilter.plyrContainer.id;
    videos.forEach((video) => {
      if (video.elements.container.id !== idToFilter) {
        video.pause();
      }
    });
  }

  onPlay() {
    this.onPauseVideos(videos, this);
    this.plyr.play();
  }

  onReady() {
    this.plyrIsReady = true;

    if (this.settingsValue?.autoplay) this.plyr.muted = true;
  }

  appear(entry) {
    if (!this.plyrIsReady) {
      setTimeout(() => this.appear(entry), 500);
    }

    if (this.settingsValue?.autoplay) this.plyr.play();
  }

  onPlaying() {
    if (this.hasPosterTarget) this.posterTarget.style.display = 'none';
    if (this.hasAnimateInClass) this.element.classList.add(this.animateInClass);
  }

  onPause() {
    console.log('onPause');
    this.plyr.pause();
  }

  unmute() {
    this.plyr.muted = false;
    this.buttonTarget.style.display = 'none';
  }

  teardown() {
    // rebuild the original state if it's an iframe
    if (this.plyrType === 'IFRAME') {
      this.element.innerHTML = '';
      if (this.hasPosterTarget) this.element.appendChild(poster);
      this.element.appendChild(this.plyrElement);

      // set poster back to display block if present
      if (this.hasPosterTarget) poster.style.display = 'block';
    }

    // destroy plyr instance
    this.plyr.destroy();
  }
}
